import * as React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import * as rsuite from "rsuite";
import "rsuite/dist/rsuite-rtl.min.css";
import moment from 'moment-jalaali';
import { useNavigate } from 'react-router-dom';



const PrintLayout = ({ children, title }) => {

    const navigate = useNavigate();
    const [PrinDate, setPrinDate] = React.useState(moment(moment(new Date()).format()).format("jYYYY/jMM/jDD"))

    const handelKeyDown = (e, row) => {
        if (e.key == "Escape") {
            Back();
        }
        if (e.key == "Enter") {
            Print();
        }
    }

    const Back = () => {
        // localStorage.removeItem("PreFactorHeaderId");
        // localStorage.removeItem("BuyOrderHeaderId");
        // localStorage.removeItem("BuyOrderHeaderId");
        var ReturnPage = localStorage.getItem("BackPage");
        localStorage.setItem("BackPage", '');
        if (ReturnPage != "" && ReturnPage != null)
            navigate("/" + ReturnPage)
        else
            window.close();

    }
    const Print = () => {
        window.print();
    }



    return (
        <div className="bg-white overflow-hidden pagebreak w-100p " onKeyDown={handelKeyDown} >

            <table className="w-100p">
                <thead className="bg-light border-bottom  border-2 border-top-0 border-end-0 border-start-0 border-danger " >


                    <div className="fw-bold Font17 pe-2 ps-2 text-center" xs={24}>
                        {title}
                    </div>
                    <div className="w-50p p-2 float-end">
                        <rsuite.HStack>
                            <rsuite.Avatar circle src="../../assets/images/Logo.png" />
                            <rsuite.VStack spacing={4}>
                                <rsuite.Text className="fw-bold Font14">فروشــگاه مهــران </rsuite.Text>
                                <rsuite.Text muted size="sm">
                                    فـــارم آســـان
                                </rsuite.Text>

                            </rsuite.VStack>
                        </rsuite.HStack>
                    </div>
                    <div className="w-50p p-2 float-start">
                        <rsuite.HStack className="text-start w-100p">
                            <rsuite.VStack spacing={4} className="w-100p align-items-end" >
                                <text className="fw-bold "> شماره تلفن : 09101172004  </text>
                                <text className="text-black-50" size="sm"> شماره ثابت : 32251005-071  </text>
                                <text className="text-black-50" size="sm"> تاریخ چاپ : {PrinDate} </text>

                            </rsuite.VStack>
                        </rsuite.HStack>
                    </div>

                </thead>


                <tbody className=" bg-white ">
                    <div className=" bg-white pt-2 pb-2 ">

                        {children}
                    </div>
                </tbody>
                <tfoot className=" print-footer border-bottom-0 border-end-0 border-start-0 border-2 p-3 border-danger border-top">

                    <div className=" bg-light pe-3 ps-3 pt-1  ">
                        <text className="text-black-50 "> آدرس : شیراز- خیابان سعـــدی - پاساژ ملـــــت - فروشــگاه مهــران (فـــارم آســـان)  </text>
                    </div>
                    <div id="printPageButton " className="pt-2 pe-3 ps-3 pb-4 ">
                        <div className="w-50p float-end">
                            <small className="d-print-none"><b> ESC :</b> بازگشت<b>| Enter  یا Ctrl+P:</b> چاپ </small>
                        </div>
                        <div className="w-50p float-start">

                            <rsuite.Button appearance="primary" size="xs" className='FocusItem print d-print-none float-start' id="printPageButton" onClick={() => Print()}>  چاپ</rsuite.Button>
                            <rsuite.Button appearance="primary" color='yellow' size="xs" className='me-2 d-print-none float-start' id="printPageButton" onClick={() => Back()}>  بازگشت</rsuite.Button>
                        </div>
                    </div>
                </tfoot>
            </table>
        </div>



    );
};

export default PrintLayout;